/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class UpdateApprovedSenderForTransitsRequest {
  public id: string = undefined;
  public approvedUtc: Date | string;
  public inactive: boolean;
}
